export default __webpack_public_path__ + "static/media/Copy.51813ee7.svg";